import { event } from '@uhg-abyss/web/tools/event';
import { logger } from '@uhg-abyss/web/tools/logger';
import { createScript } from '@uhg-abyss/web/tools/script';
import { uniqueId } from '@uhg-abyss/web/tools/uniqueId';
import { config } from '@uhg-abyss/web/tools/config';
import { lagoon } from '@optum-lagoon/sdk';

export const asyncMessaging = (options) => {
  if (options.enabled !== false) {
    const hostname = options.hostname ?? window.location.hostname;
    const generatedUniqueId = uniqueId();

    let scriptSrc = `${
      options.liveChatUrl || config('LIVE_CHAT_URL')
    }${generatedUniqueId}`;

    if (hostname === 'apps.uhcprovider.com') {
      scriptSrc = `${
        options.liveChatUrl || config('LIVE_CHAT_URL')
      }${generatedUniqueId}`;
    }

    createScript('async-msg-lp-chat-script', scriptSrc);
  }
  return {
    id: options.id,
    events: options.events,
    metadata: options.metadata,
    trigger: (tag) => {
      event.debounce(tag, 100, () => {
        if (options.logging) {
          logger.warn(`chat: ${tag.event}`, tag.data);
        }
        logger.log('Starting LivePerson Script, Tag info -', tag);

        const useUpdatedEndpoints = lagoon
          .getTable('feature-toggles')
          .getRow('US10732847_UPDATED_CORE_V2_ENDPOINTS')?.active;

        const userInfoUrl = useUpdatedEndpoints
          ? '/api/identity/ohid/userinfo/v2'
          : '/api/identity/ohid/userinfo';

        // arg 1 : provider data, arg 2: userinfo url
        window.startLiveperson(tag.data, userInfoUrl);
      });
    },
  };
};
